import React from 'react';
import { Text, View } from '@react-pdf/renderer';


const SectionTitle = ({ text, order, subText }: any) => {
  return (
    <View fixed style={{
      margin: 25,
    }}>
      <View style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          fontFamily: 'Helvetica-Bold',
        }}>
        <Text style={{
          textAlign: 'center',
          padding: 10,
          backgroundColor: 'rgb(252 211 77)',
          color: 'white',
        }}>Module {order + 1}</Text>
        <Text style={{ flex: 1, textAlign: 'center', padding: 10, color: 'rgb(252 211 77)'}}>{text}</Text>
      </View>
      {
        subText 
        ? <Text style={{
            marginTop: 12,
            textAlign: 'center',
            color: 'rgb(107 114 128)',
          }}>Objectif(s) : {subText}</Text>
        : null
      }
    </View>
  )
}

export default SectionTitle
